import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { ISelectOption } from "shared/components/Form/Fields/select/types";
import { PeopleBlockStatus } from "Bands/types";
import { peopleBlockStatuses } from "Bands/utils";

const { errors } = copy;

export const getFormFields = (
  excludeUsers?: string[] | undefined,
  onStatusChange?: (status: PeopleBlockStatus | undefined) => void
): IFormFields => {
  return [
    {
      name: "users",
      label: "Name",
      type: IFieldType.peoplePicker,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "1/5",
        mobile: {
          gridColumn: "1/7",
        },
      },
      settings: {
        excludeOptions: excludeUsers,
        includeInvitedUsers: true,
      },
    },
    {
      name: "status",
      label: "Status",
      type: IFieldType.select,
      options: peopleBlockStatuses.filter(
        ({ value }) => value !== PeopleBlockStatus.none
      ),
      placeholder: "Choose status",
      onChange: (value: ISelectOption) => {
        onStatusChange && onStatusChange(value?.value as PeopleBlockStatus);
      },
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "5/7",
        mobile: {
          gridColumn: "1/7",
        },
      },
    },
  ];
};
